import type { i18n as I18nInstance, InitOptions } from 'i18next';
import { PostProcessor } from 'i18next-subliminal';

import { IS_TRANSLATION_EDITOR_ENABLED } from './config';

/** postProcessPassResolved 가 없으면 메타가 빈 채로 심겨 대상을 특정하지 못한다. */
export const SUBLIMINAL_INIT_OPTIONS: InitOptions = IS_TRANSLATION_EDITOR_ENABLED
  ? { postProcess: 'subliminal', postProcessPassResolved: true }
  : {};

/** 플러그인을 config 에 담으면 함수가 props 로 나가 직렬화 검사에 걸린다. */
export const registerSubliminal = (instance: I18nInstance) => {
  if (!IS_TRANSLATION_EDITOR_ENABLED) {
    return;
  }

  instance.use(PostProcessor);
};
